import UpdatePrompt from './UpdatePrompt'
import { usePwaUpdate } from '../hooks/usePwaUpdate'

export function PwaUpdateBanner() {
  const { needsRefresh, applyUpdate } = usePwaUpdate()

  if (!needsRefresh) return null

  return <UpdatePrompt onReload={applyUpdate} />
}
